<nb-card>
  <nb-card-header>
    <div class="logo-container">
      <a href="#"><img width="" alt="log" src="../../../../assets/images/logo-alternative.svg" href="#"></a>
    </div>
  </nb-card-header>
  <nb-card-body>
    <h5 id="title" class="title">Confirme sua conta</h5>
    <p>Sua conta foi criada, você deve verificar seu e-mail <b>{{ email }}</b> para
      confirmação da conta.</p>
  </nb-card-body>
</nb-card>